/* eslint-disable react/no-unknown-property */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable quotes */
import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import * as styles from "./VideoPlayer.module.scss";

const cx = classNames;

const YoutubeVideo = ({ videoId, videoTitle, autoPlay, className, style, setVideoPlayer }) => {
	const videoPlayerRef = useRef();

	useEffect(() => {
		if (setVideoPlayer) {
			setVideoPlayer({
				pause: () => {
					videoPlayerRef.current.contentWindow.postMessage(
						'{"event":"command","func":"pauseVideo","args":""}',
						"*"
					);
				},
			});
		}
	}, [videoPlayerRef.current, setVideoPlayer]);

	return (
		<div div className={cx(className)} style={style}>
			<iframe
				ref={videoPlayerRef}
				className={styles.youtubePlayer}
				src={`${process.env.GATSBY_YOUTUBE_URL}/${videoId}?autoplay=${
					autoPlay ? 1 : 0
				}&rel=0&enablejsapi=1`}
				title={videoTitle}
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			/>
		</div>
	);
};
YoutubeVideo.propTypes = {
	videoId: PropTypes.string,
	videoTitle: PropTypes.string,
	className: PropTypes.string,
	style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
	setVideoPlayer: PropTypes.func,
	autoPlay: PropTypes.bool,
};

YoutubeVideo.defaultProps = {
	videoId: null,
	videoTitle: null,
	className: "",
	style: {},
	setVideoPlayer: undefined,
	autoPlay: false,
};

export default YoutubeVideo;
